<div class="column drawer-dialog">
	<div class="drawer-dialog-header display-flex-end">
		<h2 i18n="@@usageReportDialog-Title">Usage Report</h2>
		<button mat-icon-button>
			<!-- <mat-icon class="color-primary" (click)="onCloseDialog()">close</mat-icon> -->
		</button>
	</div>

	<mat-dialog-content class="drawer-dialog-content">
		<h3 class="drawer-dialog-content-header" i18n="@@usageReportDialog-deviceOwner">Device Owners (optional)</h3>
		<app-loading-indicator
			[keys]="[apiLoadingKeys.getUserProfile, apiLoadingKeys.getSentrilockCompanyId]"
			diameter="30"
		>
			<app-multi-select-typeahead
				data-automation-id="device-owners-typeahead"
				[allDropdownOptions]="deviceOwnerOptions"
				[filterOnField]="'name'"
				[placeholderText]="deviceOwnerMultiSelectSearchPlaceholder"
				[showSelectionsInInputField]="false"
				[showSelectedItemSubOption]="false"
				[selectedItemIconName]="'sl-nav-work'"
				[initiallySelectedItemIds]="deviceOwnerId"
				[initiallySelectedIdField]="'id'"
				[minCharactersForSearch]="3"
				(selectedOptionsChangedEvent)="onSelectedItemsChanged('deviceOwner', $event)"
				(searchInputChanged)="onSearchInput('deviceOwner', $event)"
			>
			</app-multi-select-typeahead>
		</app-loading-indicator>
		<mat-divider></mat-divider>

		<h3 class="drawer-dialog-content-header" i18n="@@usageReportDialog-dateValid">Date Valid</h3>
		<div class="row" style="flex-wrap: nowrap">
			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@usageReportDialog-startDateValid">Start (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="dateValidStartPicker"
					placeholder="Start (optional)"
					i18n-placeholder="@@usageReportDialog-chooseStartDateValid"
					(dateChange)="onDateValidStartDateChanged($event)"
					[ngModel]="this.usageReportFilters.utcStartDate"
					data-automation-id="start-date-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="dateValidStartPicker"
					data-automation-id="start-date-toggle"
				></mat-datepicker-toggle>
				<mat-datepicker #dateValidStartPicker data-automation-id="start-date-datepicker"></mat-datepicker>
			</mat-form-field>

			<div style="display: flex; flex-direction: column; justify-content: center; padding: 0 24px">To</div>

			<mat-form-field appearance="outline" class="column" subscriptSizing="dynamic">
				<mat-label i18n="@@usageReportDialog-endDateValid">End (optional)</mat-label>
				<input
					matInput
					[matDatepicker]="dateValidEndPicker"
					placeholder="End (optional)"
					i18n-placeholder="@@usageReportDialog-ChooseEndDateValid"
					(dateChange)="onDateValidEndDateChanged($event)"
					[ngModel]="this.usageReportFilters.utcEndDate"
					data-automation-id="end-date-input"
				/>
				<mat-datepicker-toggle
					matSuffix
					class="date-picker-primary-blue"
					[for]="dateValidEndPicker"
					data-automation-id="end-date-toggle"
				></mat-datepicker-toggle>
				<mat-datepicker #dateValidEndPicker data-automation-id="date-date-datepicker"></mat-datepicker>
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions class="margin-bottom-none">
		<div class="row content-flex-end">
			<div class="bottom-border"></div>
			<button
				mat-button
				class="secondary-button"
				i18n="@@usageReportDialog-closeWindow"
				(click)="onCloseDialog()"
				data-automation-id="usage-report-cancel-button"
			>
				Cancel
			</button>
			<button
				mat-button
				class="primary-button"
				style="margin-right: 24px"
				(click)="onGenerateReport()"
				data-automation-id="generate-usage-report-button"
			>
				{{ this.primaryButtonText }}
			</button>
		</div>
	</mat-dialog-actions>
</div>
